import { CustomerApi } from "../apis/customer";
import { InvoiceApis } from "../apis/invoice";
import { ProductApi } from "../apis/product";
import { CompanyApi } from "../apis/company";
import { formatAmount } from "../app/[lng]/application/utils/formatAmount";
import { isAxiosError } from "axios";
import { notifySessionExpired } from "../lib/sessionEvents";
import { isSessionExpiredError } from "../lib/errorUtils";
const isSessionUnauthorizedError = (error)=>{
    var _error_response;
    if (isSessionExpiredError(error)) return true;
    return isAxiosError(error) && ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 401;
};
const swallowSessionExpired = async (fn, fallback)=>{
    try {
        return await fn();
    } catch (error) {
        if (isSessionUnauthorizedError(error)) {
            notifySessionExpired();
            return fallback;
        }
        throw error;
    }
};
export const getProducts = async (param)=>{
    let { queryKey } = param;
    return swallowSessionExpired(async ()=>{
        const { data } = await ProductApi.getProducts();
        return data.products;
    }, []);
};
export const getProduct = async (param)=>{
    let { queryKey } = param;
    return swallowSessionExpired(async ()=>{
        const [_, productId] = queryKey;
        const { data } = await ProductApi.getProduct(productId);
        return data.product;
    }, {});
};
export const getCustomers = async ()=>{
    return swallowSessionExpired(async ()=>{
        const { data } = await CustomerApi.getCustomers();
        const refactoredData = data.customers.map((item, index)=>({
                ...item,
                id: index + 1,
                customer_number: item.customer_number || "",
                first_name: item.first_name ? "".concat(item.first_name.charAt(0).toUpperCase()).concat(item.first_name.slice(1)) : "",
                last_name: item.last_name ? "".concat(item.last_name.charAt(0).toUpperCase()).concat(item.last_name.slice(1)) : "",
                openinvoices: formatAmount(item.open_invoices),
                paidinvoices: formatAmount(item.paid_invoices),
                status: item.customer_status ? "".concat(item.customer_status.charAt(0).toUpperCase()).concat(item.customer_status.slice(1)) : "",
                invoice_language: item.invoice_language ? "".concat(item.invoice_language.charAt(0).toUpperCase()).concat(item.invoice_language.slice(1)) : "",
                company_name: item.company_name ? item.company_name : "",
                company_email: item.company_email ? item.company_email : "",
                company_phone_number: item.company_phone_number ? item.company_phone_number : "",
                email: item.personal_email,
                street: item.street ? "".concat(item.street.charAt(0).toUpperCase()).concat(item.street.slice(1)) : "",
                city: item.city ? "".concat(item.city.charAt(0).toUpperCase()).concat(item.city.slice(1)) : "",
                country: item.country ? "".concat(item.country.charAt(0).toUpperCase()).concat(item.country.slice(1)) : ""
            }));
        return refactoredData;
    }, []);
};
export const getCompanyDetails = async ()=>{
    return swallowSessionExpired(async ()=>{
        const { data } = await CompanyApi.getCompanyDetails();
        return data;
    }, {});
};
export const getInvoiceSettings = async ()=>{
    return swallowSessionExpired(async ()=>{
        const { data } = await InvoiceApis.getInvoiceSettings();
        return data;
    }, {});
};
export const getInvoiceDetails = async (param)=>{
    let { queryKey } = param;
    return swallowSessionExpired(async ()=>{
        const [_, invoiceId] = queryKey;
        const { data } = await InvoiceApis.getInvoiceDetails(invoiceId);
        return data;
    }, {});
};
export const getInvoices = async (param)=>{
    let { queryKey } = param;
    return swallowSessionExpired(async ()=>{
        const [_, params] = queryKey;
        const { data } = await InvoiceApis.getInvoices(params);
        var _data_invoices;
        return {
            invoices: (_data_invoices = data.invoices) !== null && _data_invoices !== void 0 ? _data_invoices : [],
            total: typeof data.total === "number" ? data.total : 0
        };
    }, {
        invoices: [],
        total: 0
    });
};
